/* Shanti Enterprise AG – ERP-Vorschläge in der Kopfzeilen-Suche (07.10.2026)
   Sobald die Eingabe wie eine Artikelnummer aussieht (mind. 2 Ziffern), werden parallel zur Shop-Suche
   die Live-Vorschläge aus dem ERP (n8n Webhook shop-artikelsuche) angezeigt:
   – Artikel im Online-Shop: Bild + Link zum Produkt
   – Artikel nur im ERP: Link zum Tool «mit Artikelnummer bestellen» (?nr=…) → als Anfrage in den Warenkorb
   Styles: assets/shanti-151.css (Abschnitt 9) */
(function () {
  var ENDPOINT = 'https://shanti.n8n.infinitenet.ch/webhook/shop-artikelsuche';
  var TOKEN = 'shanti-Shop-Suche-2026-Kp4Mz9';
  var TOOL_URL = '/products/mit-artikelnummer';
  var MAX = 6;
  var shopCache = {};
  var erpCache = {};

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').trim().toUpperCase(); }
  function looksLikeNr(q) { return (q.replace(/[^0-9]/g, '').length >= 2) && q.replace(/[^0-9A-Za-zÄÖÜäöü]/g, '').length >= 2; }

  function lookupShop(nr) {
    var key = norm(nr);
    if (key in shopCache) return Promise.resolve(shopCache[key]);
    var url = '/search/suggest.json?q=' + encodeURIComponent(key) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=show&resources[options][fields]=variants.sku';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) return null;
        return Promise.all(products.slice(0, 4).map(function (p) {
          return fetch('/products/' + p.handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        })).then(function (full) {
          var found = null;
          full.forEach(function (pj) {
            if (found || !pj) return;
            (pj.variants || []).forEach(function (v) {
              if (!found && norm(v.sku) === key) {
                var img = (v.featured_image && v.featured_image.src) || (pj.images && pj.images[0]) || pj.featured_image || '';
                found = { title: pj.title, image: img, url: '/products/' + pj.handle + (pj.variants.length > 1 ? '?variant=' + v.id : ''), available: v.available };
              }
            });
          });
          return found;
        });
      })
      .then(function (found) { shopCache[key] = found || null; return found || null; })
      .catch(function () { shopCache[key] = null; return null; });
  }

  var ctrl = null;
  function suggest(q) {
    var key = norm(q);
    if (erpCache[key]) return Promise.resolve(erpCache[key]);
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    var url = ENDPOINT + '?token=' + encodeURIComponent(TOKEN) + '&q=' + encodeURIComponent(q) + '&limit=' + MAX;
    return fetch(url, { signal: ctrl.signal })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.ok) erpCache[key] = d; return d; })
      .catch(function (e) { return (e && e.name === 'AbortError') ? undefined : null; });
  }

  function thumb(src) { return String(src || '').replace(/(\.[a-z]{3,4})(\?|$)/i, '_120x120$1$2'); }

  function render(box, data, q) {
    if (!data || !data.ok) { box.hidden = true; box.innerHTML = ''; return; }
    var items = (data.items || []).slice(0, MAX);
    var fuzzy = (data.suggestions || []).slice(0, 3);
    if (!items.length && !fuzzy.length) { box.hidden = true; box.innerHTML = ''; return; }
    var html = '<p class="shanti-erp__title">Artikelnummern</p><ul class="shanti-erp__list">';
    items.forEach(function (it) {
      html += '<li class="shanti-erp__item" data-nr="' + esc(it.nr) + '">' +
        '<a class="shanti-erp__link" href="' + esc(TOOL_URL + '?nr=' + encodeURIComponent(it.nr)) + '">' +
        '<span class="shanti-erp__img"></span>' +
        '<span class="shanti-erp__text"><span class="shanti-erp__nr">' + esc(it.nr) + '</span>' +
        '<span class="shanti-erp__bez">' + esc(it.bez) + '</span>' +
        '<span class="shanti-erp__state">… wird geprüft</span></span></a></li>';
    });
    if (fuzzy.length) {
      html += '<li class="shanti-erp__head">Meinten Sie …</li>';
      fuzzy.forEach(function (it) {
        html += '<li class="shanti-erp__item shanti-erp__item--fuzzy" data-nr="' + esc(it.nr) + '">' +
          '<a class="shanti-erp__link" href="' + esc(TOOL_URL + '?nr=' + encodeURIComponent(it.nr)) + '">' +
          '<span class="shanti-erp__img"></span>' +
          '<span class="shanti-erp__text"><span class="shanti-erp__nr">' + esc(it.nr) + '</span>' +
          '<span class="shanti-erp__bez">' + esc(it.bez) + '</span>' +
          '<span class="shanti-erp__state">… wird geprüft</span></span></a></li>';
      });
    }
    html += '</ul><a class="shanti-erp__tool" href="' + esc(TOOL_URL + '?nr=' + encodeURIComponent(q)) + '">Mehrere Artikelnummern bestellen →</a>';
    box.innerHTML = html;
    box.hidden = false;
    // Shop-Abgleich je Vorschlag (Bild + Produktlink, sonst Anfrage über das Tool)
    box.querySelectorAll('.shanti-erp__item').forEach(function (li) {
      var nr = li.getAttribute('data-nr');
      lookupShop(nr).then(function (found) {
        if (!li.isConnected) return;
        var a = li.querySelector('.shanti-erp__link');
        var st = li.querySelector('.shanti-erp__state');
        var im = li.querySelector('.shanti-erp__img');
        if (found) {
          li.classList.add('is-shop');
          a.href = found.url;
          st.textContent = found.available === false ? 'Im Shop · zurzeit ausverkauft' : 'Im Online-Shop';
          if (found.image) im.innerHTML = '<img src="' + esc(thumb(found.image)) + '" alt="" loading="lazy">';
        } else {
          li.classList.add('is-erp');
          st.textContent = 'Nicht im Online-Shop, als Anfrage bestellen';
        }
      });
    });
  }

  function init(ps) {
    if (!ps || ps.dataset.shantiErp) return;
    var input = ps.querySelector('.search__input');
    var anchor = ps.querySelector('.search__form-container');
    if (!input || !anchor) return;
    ps.dataset.shantiErp = '1';
    var box = document.createElement('div');
    box.className = 'shanti-erp';
    box.hidden = true;
    anchor.insertAdjacentElement('afterend', box);
    var timer = null, last = '';
    function run() {
      var q = input.value.trim();
      if (q === last) return;
      last = q;
      if (!looksLikeNr(q)) { box.hidden = true; box.innerHTML = ''; return; }
      suggest(q).then(function (d) { if (d === undefined) return; if (input.value.trim() !== q) return; render(box, d, q); });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 350); });
    input.form && input.form.addEventListener('reset', function () {
      last = '';
      setTimeout(function () { if (!input.value.trim()) { box.hidden = true; box.innerHTML = ''; } else { run(); } }, 0);
    });
    // Enter auf einer Artikelnummer ohne Shop-Treffer: direkt ins Tool statt leere Suchseite
    input.form && input.form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!looksLikeNr(q)) return;
      var first = box.querySelector('.shanti-erp__item:not(.shanti-erp__item--fuzzy) .shanti-erp__link');
      var hasShop = ps.hasAttribute('results') && ps.querySelector('#predictive-search-results-products-list li');
      if (first && !hasShop) { e.preventDefault(); window.location.href = first.href; }
    });
  }

  function boot() { document.querySelectorAll('predictive-search').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Falls der Header-Abschnitt im Editor neu gerendert wird
  document.addEventListener('shopify:section:load', boot);
})();
